<template>
  <div>
    <InputLabel value="Total Allocation" margin-bottom="10" font-size="22">
      <div v-if="showErrorMessage" class="error-message">Values cannot be positive.</div>
    </InputLabel>
    <el-table
      class="allocation-total-table"
      :data="computedData"
      empty-text="No Data Available"
      header-cell-class-name="table-header-dark">
      <el-table-column
        label="A"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="money-input" v-if="!readonly">
            <money
              v-model="allocation.allocationTotalA"
              v-bind="money"
              @blur.native="blurA"></money>
          </div>
          <div v-else>{{scope.row.allocationTotalA | currency}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="A1"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="money-input" v-if="!readonly">
            <money
              v-model="allocation.allocationTotalA1"
              v-bind="money"
              @blur.native="blurA1"></money>
          </div>
          <div v-else>{{scope.row.allocationTotalA1 | currency}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="BC"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="money-input" v-if="!readonly">
            <money
              v-model="allocation.allocationTotalBC"
              v-bind="money"
              @blur.native="blurBC"></money>
          </div>
          <div v-else>{{scope.row.allocationTotalBC | currency}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="F"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="money-input" v-if="!readonly">
            <money
              v-model="allocation.allocationTotalF"
              v-bind="money"
              @blur.native="blurF"></money>
          </div>
          <div v-else>{{scope.row.allocationTotalF | currency}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="T"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="money-input" v-if="!readonly">
            <money
              v-model="allocation.allocationTotalT"
              v-bind="money"
              @blur.native="blurT"></money>
          </div>
          <div v-else>{{scope.row.allocationTotalT | currency}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="Total"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="money-input">
            <money
              v-model="scope.row.allocationTotal"
              v-bind="money"
              class="total-display"></money>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Money } from 'v-money';
import InputLabel from '../misc/InputLabel.vue';

export default {
  name: 'AllocationTotalTable',
  components: {
    Money,
    InputLabel,
  },
  props: {
    allocation: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedData() {
      return [{
        allocationTotalA: this.allocation.allocationTotalA,
        allocationTotalA1: this.allocation.allocationTotalA1,
        allocationTotalBC: this.allocation.allocationTotalBC,
        allocationTotalF: this.allocation.allocationTotalF,
        allocationTotalT: this.allocation.allocationTotalT,
        allocationTotal:
          this.allocation.allocationTotalA
          + this.allocation.allocationTotalA1
          + this.allocation.allocationTotalBC
          + this.allocation.allocationTotalF
          + this.allocation.allocationTotalT,
      }];
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false,
      },
      showErrorMessage: false,
    };
  },
  methods: {
    showError() {
      this.showErrorMessage = true;
      setTimeout(() => {
        this.showErrorMessage = false;
      }, 3500);
    },
    blurA() {
      if (this.allocation.allocationTotalA > 0) {
        this.allocation.allocationTotalA = 0;
        this.showError();
      }
    },
    blurA1() {
      if (this.allocation.allocationTotalA1 > 0) {
        this.allocation.allocationTotalA1 = 0;
        this.showError();
      }
    },
    blurBC() {
      if (this.allocation.allocationTotalBC > 0) {
        this.allocation.allocationTotalBC = 0;
        this.showError();
      }
    },
    blurF() {
      if (this.allocation.allocationTotalF > 0) {
        this.allocation.allocationTotalF = 0;
        this.showError();
      }
    },
    blurT() {
      if (this.allocation.allocationTotalT > 0) {
        this.allocation.allocationTotalT = 0;
        this.showError();
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .error-message {
    display: inline-flex;
    font-size: 13px;
    font-style: italic;
    margin-left: 13px;
    color: #EB5757;
  }

  .allocation-total-table {
    /deep/ .el-table__row {
      background: rgba(238, 245, 247, 0.5);
    }

    .money-input {
      width: 100%;
      display: block;
      font-size: 13px;
      .v-money {
        width: 100%;
        height: 32px;
        line-height: 32px;
        background-color: #FFF;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        outline: 0;
        padding: 0 15px;
        display: inline-block;
        box-sizing: border-box;
        &:hover {
          border-color: #C0C4CC;
        }
        &:focus {
          border-color: #0373CB;
        }
        &.total-display {
          background: #748C9C;
          color: white;
          font-weight: bold;
          pointer-events: none;
        }
      }
    }
  }
</style>
